import { getEnvVar } from '@studio/environment/getEnvVar';

//Webpack  exposes a global variable called __webpack_public_path__ that allows you to set publicUrl during runtime.
//Refer https://webpack.js.org/guides/public-path/

/* eslint-disable import/first */
if (!!getEnvVar('REACT_APP_PUBLIC_URL')) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = getEnvVar('REACT_APP_PUBLIC_URL');
}
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConnectedRouter } from 'connected-react-router';
import { Provider as ReduxProvider, ReactReduxContext } from 'react-redux';
import getViewPermissions from '@shoflo/studio-redux/actions/permission/getPermissions';
import { AppErrorBoundary } from '@shoflo/polymer/components/ErrorBoundary/AppErrorBoundary';
import App from './App';
import { store, history } from './store/store';
import './bootstrap-combined.scss';
import './index.css';
import '@shoflo/polymer/styles/custom-fonts.css';
import getUserFromSession from '@shoflo/studio-redux/actions/user/getUserFromSession';
import { logEventLoopLag } from '@studio/logger/datadog/logEventLoopLag';
import { initRUM } from '@studio/logger/datadog/initRum';
import packageJSON from '../package.json';

const { version, name: appName } = packageJSON;
logEventLoopLag();
initRUM(appName, version);

const reduxDevModeCheckFrequency =
  process.env.NODE_ENV === 'development' ? 'always' : 'never';

const root = createRoot(document.getElementById('root'));
root.render(
  <AppErrorBoundary>
    <ReduxProvider
      store={store}
      context={ReactReduxContext}
      noopCheck={reduxDevModeCheckFrequency}
    >
      <ConnectedRouter history={history} context={ReactReduxContext}>
        <App />
      </ConnectedRouter>
    </ReduxProvider>
  </AppErrorBoundary>
);

store.dispatch(getUserFromSession());
store.dispatch(getViewPermissions());
